<template>
  <div class="row">
    <div :class="[code_class]">
      <span
        :class="[
          'bmd-form-group d-block form-label-group',
          is_focused_code ? 'focused' : '',
        ]"
      >
        <!-- <input type="text" class="form-control" v-model="code" :placeholder="code_placeholder" autocomplete="off" style="cursor: auto;" :id="'code'+id"> -->
        <v-select
          :readonly="readonly"
          :id="'code' + id"
          :options="options_computed"
          label="display_text"
          :class="[
            'form-control',
            selected_code.value !== '' ? 'vs--selected' : '',
          ]"
          @search="search_code"
          v-model="selected_code"
          :placeholder="code_placeholder"
          @focus="focused_code"
          @blur="blurred_code"
        ></v-select>
        <!-- <div class="input-loading loading" v-if="is_code_search"></div> -->
        <label
          :for="'code' + id"
          class="form-label-group-label shorter text-truncate"
          v-html="code_placeholder"
        ></label>
      </span>
    </div>
    <div :class="[message_class]">
      <span
        :class="[
          'bmd-form-group d-block form-label-group',
          is_focused ? 'focused' : '',
        ]"
      >
        <v-select
          :readonly="readonly"
          :id="'value' + id"
          :options="options"
          label="display_text"
          :class="['form-control', selected.value !== '' ? 'vs--selected' : '']"
          @search="search"
          v-model="selected"
          :placeholder="value_placeholder"
          @focus="focused"
          @blur="blurred"
        ></v-select>
        <label :for="'value' + id" class="form-label-group-label shorter">{{
          value_placeholder
        }}</label>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "code-value",
  props: {
    label: String,
    value_placeholder: String,
    code_placeholder: String,
    type: String,
    value: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    code_class: {
      type: String,
      default: "col-lg-3",
    },
    message_class: {
      type: String,
      default: "col-lg-9",
    },
  },
  computed: {
    id() {
      return this._uid;
    },
    options_computed() {
      var t = [];
      this.options.forEach((item) => {
        t.push({
          value: item.value,
          display_text: item.value,
          display_text2: item.display_text,
        });
      });
      return t;
    },
  },
  data() {
    return {
      code: "",
      selected: { value: "" },
      selected_code: { value: "" },
      options: [],
      is_focused: false,
      is_focused_code: false,
      is_code_search: false,
      is_value_search: false,
      code_timeout: null,
      is_backward: false,
    };
  },
  mounted() {
    this.search("");
    this.is_backward = true;
    this.is_code_search = true;
    this.is_value_search = true;
    this.selected = this.value;
    this.code = this.value.value;
    this.selected_code = {
      value: this.selected.value,
      display_text: this.selected.value,
      display_text2: this.selected.display_text,
    };
    setTimeout(() => {
      this.is_code_search = false;
      this.is_value_search = false;
      this.is_backward = false;
    }, 2000);
  },
  methods: {
    loadCode(code) {
      this.is_code_search = true;
      axios
        .get(
          window.base +
            "/library/" +
            this.type +
            "?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          console.log("code-value response");
          console.log(response.data);
          this.selected = response.data[0];
          console.log(this.selected);
          setTimeout(() => {
            this.is_code_search = false;
          }, 500);
        });
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.options = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.options.push(item);
          });
        });
    },
    search(val) {
      this.getLibrary(this.type, val, 1000);
    },
    search_code(val) {
      axios
        .get(
          window.base +
            "/library/" +
            this.type +
            "?code=" +
            val +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          console.log("search code");
          console.log(response);
          this.options = [];
          console.log("pries foreach");
          response.data.forEach((item) => {
            console.log("foreach");
            if (item.value !== "··········")
              this.options.push({
                value: item.value,
                display_text: item.display_text,
              });
          });
          console.log("requesto pabaiga");
        });
    },
    blurred() {
      this.focused = false;
    },
    focused() {
      this.focused = true;
    },
    blurred_code() {
      this.focused_code = false;
    },
    focused_code() {
      this.focused_code = true;
    },
  },
  watch: {
    selected_code() {
      if (!this.is_value_search) {
        this.is_backward = true;
        this.selected = {
          value: this.selected_code.value,
          display_text: this.selected_code.display_text2,
        };
        this.$emit("input", this.selected);
        setTimeout(() => {
          this.is_backward = false;
        }, 500);
      }
    },
    selected() {
      if (!this.is_backward) {
        this.is_value_search = true;
        this.selected_code = {
          value: this.selected.value,
          display_text: this.selected.value,
          display_text2: this.selected.display_text,
        };
        this.$emit("input", this.selected);
        setTimeout(() => {
          this.is_value_search = false;
        }, 500);
      }
      // this.is_value_search = true
      // this.code = this.selected.value
      // if(!this.is_backward)
      //     this.$emit('input', this.selected)
      // setTimeout(()=>{
      //     this.is_value_search = false
      // }, 500)
    },
    code() {
      this.code_timeout = setTimeout(() => {
        if (!this.is_value_search && !this.is_code_search)
          this.loadCode(this.code);
      }, 1000);
    },
    value() {
      this.is_backward = true;
      this.is_code_search = true;
      this.is_value_search = true;
      this.selected = this.value;
      console.log(this.value);
      this.code = this.value.value;
      this.selected_code = {
        value: this.selected.value,
        display_text: this.selected.value,
        display_text2: this.selected.display_text,
      };
      setTimeout(() => {
        this.is_code_search = false;
        this.is_value_search = false;
        this.is_backward = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.input-loading {
  width: 12px;
  height: 12px;
  bottom: 0;
  top: unset;
  right: 0;
  left: unset;
  opacity: 0.5;
  border-width: 2px;
  bottom: 10px;
}
.mx-icon-calendar,
.mx-icon-clear {
  right: 20px;
}
</style>
